"use client";

import MobileBannerSkeleton from "./components/MobileBannerSkeleton";
import DesktopBannerSkeleton from "./components/DesktopBannerSkeleton";
import { useDeviceType } from "@/shared/context/DeviceContext";

export default function BannerSkeleton() {
  const deviceType = useDeviceType();
  
  return deviceType === "mobile" ? (
    <MobileBannerSkeleton />
  ) : (
    <DesktopBannerSkeleton />
  );
}
